import { render, staticRenderFns } from "./give-student.pug?vue&type=template&id=4e0efb80&lang=pug&"
import script from "./give-student.ts?vue&type=script&lang=ts&"
export * from "./give-student.ts?vue&type=script&lang=ts&"
import style0 from "./give-student.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports